import React, { useEffect, useRef, useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink } from 'reactstrap';
import { RefreshIcon } from '../icons';
import Button from '../button';

export interface TabDropDownItem {
  itemTitle?: string;
  content: React.JSX.Element;
}

export interface TabWithDropDown {
  title: string;
  items: TabDropDownItem[];
}

interface TabsWithDropDownProps {
  tabs: TabWithDropDown[];
  hasRefresh?: boolean
  refreshHandle?: () => void;
  onItemClickhandle?: (item:TabDropDownItem) => void;
}

const TabsWithDropDown: React.FC<TabsWithDropDownProps> = (
  { tabs, hasRefresh = false, refreshHandle = () => { },onItemClickhandle }) =>
  {
  const [tabIndex,setTabIndex] = useState(0) ; // Current tab index
  const [previousTabIndex, setPreviousTabIndex] = useState(0); 
  const [item,setItem] = useState<TabDropDownItem>();
  const [dropdownOpen, setDropdownOpen] = useState<boolean[]>([]);
  const [selectedItemTitle, setSelectedItemTitle] = useState ('');

  const itemClicked = useRef(false);

  const toggle = (tabIndex:number) => {
    setDropdownOpen(prevState => {
      return prevState.map((state, index) => {
        if (tabIndex === index) {
          return !state;
        } else {
          return false;
        }
      });
    });
  }
  const dropDownItemClick = (index:number,item:TabDropDownItem)=>{
    itemClicked.current = true;
    setItem(item)
    setTabIndex(index)
    setSelectedItemTitle(item.itemTitle||'');
    onItemClickhandle?.(item);
  };
  useEffect(()=>{
    let dropdownOpenList:boolean[] = [];
    for (var i = 0; i < tabs.length; i++) {
      dropdownOpenList.push(false);
    }
    setDropdownOpen(dropdownOpenList);
  },[tabs])

  useEffect(()=>{
    if(tabs[tabIndex]?.items.length===1) {setItem(tabs[tabIndex]?.items[0])}
  },[tabs,tabIndex])

  const tabClick = (index:number,tab:TabWithDropDown) =>{
    if(index!==tabIndex){ 
      setPreviousTabIndex(tabIndex); 
      setTabIndex(index);
       if(tabs[index]?.items?.length === 1){
         setItem(tab?.items[0])
         setSelectedItemTitle(tab?.items[0]?.itemTitle||'')
         onItemClickhandle?.(tab?.items[0]);
       }
    } 
  }

  const onDdlKeyDown = (event: any, index:number,tab:TabWithDropDown) => {
    if (event.key === 'Enter') {
      if(index!==tabIndex){
        tabClick(index,tab)
      }
    }
  }

  const handleDropdownBlur = () => {
    
    /*setTimeout(() => {
      if (!itemClicked.current) {
        setTabIndex(previousTabIndex); 
      }else{
        itemClicked.current = false;
        setPreviousTabIndex(tabIndex)
      }
    }, 300);*/
  };

  return (
    <div className="oms-frame">
      <Nav tabs card>
        {tabs.map((tab, index) => {
          if(tab.items?.length===1) return (
            <NavItem key={'tab-'+index+"-"+0} tabIndex={0} onKeyDown={(event) => onDdlKeyDown(event,index,tab)}>
              <NavLink className="pe-force" active={index===tabIndex} onClick={() => { tabClick(index,tab)}}>
                {tab.title}
              </NavLink>
            </NavItem>)
          if(tab.items?.length>1) return (
            <Dropdown key={'tab-'+index} nav
              isOpen={dropdownOpen[index]&&index===tabIndex} toggle={()=>toggle(index)} active={index===tabIndex}
              onBlur={handleDropdownBlur}>
              <DropdownToggle nav caret onClick={()=>{tabClick(index,tab)}} onKeyDown={(event) => onDdlKeyDown(event,index,tab)}>
                {tab.title} <b>{tabIndex===index&&selectedItemTitle}</b>
              </DropdownToggle>
              <DropdownMenu>
                {
                  tab.items.map((item,index2) => {
                     return <DropdownItem key={index+'-'+index2} onClick={()=>dropDownItemClick(index,item)}>{item&&item.itemTitle}</DropdownItem>
                  })
                }
              </DropdownMenu>
            </Dropdown>

          )
        }

        )}

        {hasRefresh &&
          <Button color="link" className="ms-auto" aria-label="Refresh" onClick={refreshHandle}>
            <RefreshIcon />
          </Button>
        }
      </Nav>

      <div className="p-3">
        {item?.content}
      </div>
    </div>
  );
};

export default TabsWithDropDown;
